import { render, staticRenderFns } from "./EditarCandidatoCalificacionDialogComponent.vue?vue&type=template&id=ebcf3a1e"
import script from "./EditarCandidatoCalificacionDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarCandidatoCalificacionDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports